var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempImg8865(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-5 {\n        opacity: .3;\n      }\n\n      .cls-2 {\n        opacity: .4;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #042b62;\n      }\n\n      .cls-7 {\n        fill: #263238;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        opacity: .2;\n      }\n\n      .cls-9 {\n        fill: #a02724;\n      }\n\n      .cls-10 {\n        fill: #b55b52;\n      }\n\n      .cls-11 {\n        fill: #f5f5f5;\n      }\n\n      .cls-12 {\n        fill: #fafafa;\n      }\n\n      .cls-13 {\n        fill: #e6e6e6;\n      }\n\n      .cls-4 {\n        opacity: .1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-61",
    className: "cls-11",
    cx: 540.19,
    cy: 923.12,
    rx: 485.81,
    ry: 28.36
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Account--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.98,154.98h-364.14c-15.73-.11-28.57,12.56-28.68,28.29,0,.59.01,1.18.04,1.77l34.15,708c1.01,16.73,14.76,29.85,31.52,30.07h364.14c15.72.11,28.55-12.55,28.66-28.27,0-.6-.01-1.2-.04-1.8l-34.13-708c-1.01-16.73-14.76-29.85-31.52-30.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M650.44,154.98h-364.24c-15.72-.11-28.55,12.55-28.66,28.27,0,.6.01,1.2.04,1.8l34.13,708c1.01,16.73,14.76,29.85,31.52,30.07h364.14c15.72.11,28.55-12.55,28.66-28.27,0-.6-.01-1.2-.04-1.8l-34.13-708c-1.01-16.69-14.7-29.8-31.42-30.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.21,903.07c-5.56-.14-10.1-4.48-10.5-10.02l-34.08-708c-.25-5.28,3.83-9.76,9.11-10.01.15,0,.29-.01.44-.01h364.14c5.57.12,10.12,4.47,10.5,10.02l34.13,708c.25,5.28-3.83,9.76-9.11,10.01-.14,0-.27.01-.41.01h-364.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.03,898.06c-2.77-.09-5.03-2.25-5.26-5.01l-34.13-708c-.1-2.67,1.99-4.91,4.66-5.01.03,0,.07,0,.1,0h364.14c2.78.08,5.05,2.24,5.26,5.01l34.13,708c.1,2.67-1.99,4.91-4.66,5.01-.03,0-.07,0-.1,0h-364.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M431.93,857.37h-72.14c-4.11-.05-7.48-3.26-7.72-7.37l-5.26-109.52c-.26-3.88,2.67-7.24,6.55-7.5.18-.01.36-.02.54-.02h72.26c4.1.03,7.47,3.25,7.69,7.34l5.19,109.54c.25,3.89-2.71,7.25-6.6,7.5-.17.01-.34.02-.52.01h0ZM353.8,735.52c-1.26,0-2.47.5-3.36,1.4-.86.93-1.31,2.17-1.25,3.43l5.29,109.49c.15,2.78,2.43,4.98,5.21,5.01h72.24c2.53.02,4.6-2.02,4.62-4.55,0-.1,0-.21,0-.31l-5.29-109.52c-.13-2.78-2.4-4.97-5.19-5.01l-72.26.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M425.11,760.95h-67.83c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h67.9c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M425.81,775.11h-67.93c-.69-.01-1.24-.57-1.25-1.25,0-.69.56-1.25,1.25-1.25h67.93c.69,0,1.25.56,1.25,1.25-.01.69-.57,1.24-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M426.49,789.27h-67.93c-.69-.01-1.24-.57-1.25-1.25,0-.69.56-1.25,1.25-1.25h67.93c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M427.17,803.42h-67.9c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h67.9c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M427.84,817.58h-67.9c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h67.9c.69,0,1.25.56,1.25,1.25s-.56,1.25-1.25,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M414.61,831.74h-54c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25h54c.69,0,1.25.56,1.25,1.25-.01.69-.57,1.24-1.25,1.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M608.35,247.41h-248.05l24.18,501.39c2.45,42.62,37.49,76.06,80.18,76.52h248.05l-24.15-501.39c-2.42-42.64-37.49-76.1-80.2-76.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M669.11,247.41h-308.74c42.69.44,77.74,33.89,80.18,76.52l19.72,408.16c2.45,42.62,37.49,76.06,80.18,76.52h155.67c39.91.42,72.59-31.6,73.01-71.5.02-1.67-.02-3.35-.12-5.02l-19.69-408.16c-2.42-42.64-37.49-76.1-80.2-76.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M613.31,732.09c2.37,39.82-28,74.03-67.82,76.4-1.66.1-3.33.14-4.99.12h308.71c39.91.39,72.57-31.65,72.96-71.56.02-1.66-.02-3.31-.12-4.97h-308.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M712.58,500.75h-218.19c-3.17-.03-5.78-2.52-5.96-5.69h0c-.17-2.97,2.11-5.51,5.08-5.68.11,0,.22,0,.33,0h218.19c3.21-.02,5.88,2.48,6.06,5.69h0c.17,2.97-2.11,5.51-5.08,5.68-.15,0-.29.01-.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M714.28,536.25h-218.19c-3.17-.03-5.78-2.52-5.96-5.69h0c-.17-2.97,2.11-5.51,5.08-5.68.11,0,.22,0,.33,0h218.21c3.16.05,5.75,2.53,5.94,5.69h0c.17,2.97-2.11,5.51-5.08,5.68-.11,0-.22,0-.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M716.01,571.73h-218.21c-3.17-.03-5.78-2.52-5.96-5.69h0c-.17-2.97,2.11-5.51,5.08-5.68.11,0,.22,0,.33,0h218.34c3.17.03,5.78,2.52,5.96,5.69h0c.17,2.97-2.11,5.51-5.08,5.68-.15,0-.31.01-.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M717.71,607.29h-218.19c-3.17-.05-5.77-2.52-5.96-5.69h0c-.17-2.97,2.11-5.51,5.08-5.68.11,0,.22,0,.33,0h218.19c3.17.03,5.78,2.52,5.96,5.69h0c.17,2.97-2.11,5.51-5.08,5.68-.11,0-.22,0-.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M632.67,642.79h-131.44c-3.17-.03-5.78-2.52-5.96-5.69h0c-.17-2.97,2.11-5.51,5.08-5.68.11,0,.22,0,.33,0h131.44c3.17.03,5.78,2.52,5.96,5.69h0c.17,2.97-2.11,5.51-5.08,5.68-.11,0-.22,0-.33,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 597.58,
    cy: 378.1,
    rx: 66.92,
    ry: 70.23,
    transform: "translate(-90.41 541.59) rotate(-45.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M654.15,378.05c.47,9.31-1.43,18.59-5.54,26.96-9.08,18.32-27.84,29.82-48.28,29.62-21.08-.16-40.53-11.41-51.16-29.62-4.88-8.18-7.68-17.44-8.14-26.96-1.74-29.45,20.72-54.74,50.17-56.48,1.22-.07,2.45-.1,3.68-.09,31.54.39,57.42,25.09,59.28,56.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648.61,405.01c-9.08,18.32-27.84,29.82-48.28,29.62-21.08-.16-40.53-11.41-51.16-29.62,14.42-9.89,31.52-15.14,49.01-15.03,17.91.03,35.43,5.26,50.44,15.03Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 596.63,
    cy: 358.67,
    rx: 24.6,
    ry: 25.81,
    transform: "translate(-76.79 535.05) rotate(-45.69)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-male--inject-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "807.69 904.32 789.3 904.32 787.44 861.68 805.86 861.68 807.69 904.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "787.47 861.7 788.4 883.68 806.81 883.68 805.86 861.7 787.47 861.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "964.36 854.36 946.87 860.08 924.85 822.42 942.36 816.7 964.36 854.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "942.36 816.7 924.85 822.42 936.23 841.83 953.71 836.12 942.36 816.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M869.93,288.4c2.28,2.78,4.21,5.26,6.19,7.99,1.98,2.73,3.86,5.34,5.74,8.04,3.71,5.44,7.27,11,10.6,16.74,6.93,11.64,12.59,24,16.86,36.86l.43,1.25.2.65.28,1.03.5,2.05.28,1.88c.3,2.25.39,4.52.28,6.79-.23,3.82-.79,7.62-1.65,11.35-1.59,6.68-3.69,13.23-6.29,19.59-4.95,12.19-10.96,23.93-17.94,35.08l-12.53-5.99c3.76-11.75,7.52-23.78,10.27-35.48,1.44-5.64,2.52-11.36,3.26-17.14.31-2.49.4-5.01.28-7.52-.04-.89-.16-1.78-.35-2.66l-.13-.45c-.05-.08-.09-.16-.13-.25h0l-.2-.48-.4-.98-1.68-3.93-1.88-3.91c-1.25-2.51-2.63-5.21-4.01-7.82-2.86-5.16-5.94-10.3-9.15-15.41-3.21-5.11-6.61-10.02-10.02-15.03-3.41-5.01-7.14-10.02-10.52-14.56l21.72-17.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M874.01,428.61l-7.19,15.91h20.57s3.28-12.08-4.18-16.96l-9.2,1.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "869.23 462.42 888.32 458.73 887.39 444.53 866.82 444.53 869.23 462.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M778.77,207.65c0,1.5-.78,2.71-1.75,2.71s-1.75-1.2-1.75-2.71.8-2.68,1.75-2.68,1.75,1.2,1.75,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M778.22,210.35c-1.77,4.53-4.15,8.8-7.09,12.68,2.05,1.47,4.64,1.96,7.09,1.35v-14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M784.04,199.43c-.18,0-.36-.06-.5-.18-1.77-1.33-4.06-1.75-6.19-1.13-.47.13-.95-.15-1.08-.62-.11-.4.08-.83.45-1.01,2.68-.85,5.6-.35,7.84,1.35.38.29.47.83.2,1.23-.18.22-.44.35-.73.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M826.71,224.76c-2.66,13.48-5.29,38.16,4.13,47.13,0,0-3.68,13.66-28.69,13.66-27.56,0-13.15-13.66-13.15-13.66,15.03-3.58,14.63-14.71,12-25.18l25.71-21.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M834.45,276.58c1.98-4.31,4.16-9.27-.35-10.82-5.01-1.7-31.97-3.43-41.32-.23-5.12,1.42-8.12,6.72-6.7,11.84.01.05.03.09.04.14l48.33-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M943.09,864.46c-1.35,1.3-2.88,2.36-4.03,2.18-.75-.15-1.32-.75-1.43-1.5-.15-.58-.04-1.19.3-1.68,1.5-2.33,7.52-3.33,7.84-3.36.16-.02.33.04.43.18.1.14.1.33,0,.48-.9,1.34-1.94,2.58-3.11,3.71ZM939.01,863.51c-.13.12-.25.26-.35.4-.2.29-.27.66-.18,1,.2.78.58.85.7.85,1.28.2,4.01-2.51,5.69-4.61-2.1.34-4.11,1.15-5.86,2.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M946.1,860.83l-.2.13c-2.08.55-7.52.2-8.67-1.55-.35-.58-.27-1.32.2-1.8.44-.51,1.06-.83,1.73-.88,2.76-.2,6.74,3.33,6.92,3.48.12.1.17.27.13.43,0,.08-.04.15-.1.2ZM938.25,858.02l-.15.15c-.35.43-.2.65-.15.75.68,1.03,4.49,1.6,6.84,1.33-1.56-1.41-3.49-2.33-5.56-2.66-.35.03-.68.18-.93.43h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M781.88,905.25c-2.36,0-4.64-.33-5.39-1.38-.42-.57-.42-1.34,0-1.9.3-.52.8-.89,1.38-1.03,3.06-.83,9.5,2.83,9.77,3.01.16.09.24.27.2.45-.03.17-.16.31-.33.35-1.86.33-3.75.49-5.64.5ZM778.97,901.69c-.28-.04-.57-.04-.85,0-.36.07-.67.29-.85.6-.3.55-.2.83,0,.98.85,1.18,5.51,1.2,8.92.73-2.23-1.23-4.68-2.01-7.22-2.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M787.44,904.75h-.18c-2.2-1-6.61-5.01-6.29-7.07,0-.5.43-1.1,1.63-1.23.9-.1,1.81.17,2.51.75,2.33,1.93,2.83,6.89,2.86,7.09,0,.16-.08.3-.2.4-.1.06-.21.08-.33.05ZM782.96,897.23h-.25c-.8,0-.85.38-.85.48-.2,1.25,2.78,4.38,5.01,5.74-.22-2.1-1.09-4.09-2.51-5.66-.4-.32-.89-.49-1.4-.5v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M945.35,858.05l15.03-14.31c.54-.53,1.38-.61,2-.18l13.93,9.32c1.23.83,1.55,2.49.72,3.72-.12.18-.26.34-.42.49-5.29,5.01-8.12,7.04-14.68,13.3-4.06,3.88-16.14,17.04-21.72,22.4-5.59,5.36-11.6.5-9.8-2.18,8.12-12.05,13.18-23.6,13.63-29.69.08-1.08.54-2.1,1.3-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M789.4,902.19h20.04c.75,0,1.4.52,1.55,1.25l3.63,16.36c.33,1.43-.56,2.86-1.99,3.19-.21.05-.43.07-.65.07-7.27,0-17.74-.53-26.86-.53-10.65,0-19.84.58-32.35.58-7.52,0-9.65-7.64-6.49-8.34,14.38-3.13,26.16-3.48,38.59-11.15,1.34-.89,2.9-1.38,4.51-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M763.19,313.66c-7.32,10.77-14.86,20.85-22.98,30.79-8.15,10.07-16.86,19.67-26.08,28.76l-3.56,3.46-.9.85-.65.6-.95.68c-1.18.95-2.45,1.79-3.78,2.51-4.23,2.23-8.88,3.54-13.66,3.83-7.28.43-14.59-.18-21.7-1.8-12.89-2.84-25.38-7.23-37.21-13.08l4.61-13.03c11.73,2.35,23.6,3.97,35.53,4.86,5.24.41,10.52.2,15.71-.65,1.49-.22,2.91-.78,4.16-1.63.13,0,0-.15,0-.15h0l.2-.2.73-.83,2.98-3.26c7.82-8.92,15.41-18.44,22.78-28.16,7.37-9.72,14.76-19.69,21.8-29.42l22.98,15.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M863.81,276.08c17.24,3.96,37.03,50.99,37.03,50.99l-34.65,23.75c-8.61-12.37-16.24-25.39-22.83-38.94-10.27-21.52,2.81-39.86,20.45-35.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.44,306.14l16.39,43.62-1.63,1.13s-7.09-10.02-14.76-23.38v-21.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M760.68,277s-19.59,22.12-1.08,159.1h98.44c.68-15.03-8.82-88.85,5.76-160.06-10.89-2.09-21.9-3.48-32.97-4.16-13.94-.8-27.91-.8-41.84,0-9.56.96-19.02,2.67-28.31,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M771.61,316.62c-2.56,15.54-9.28,30.11-19.44,42.14-.4-8.82-.55-16.74-.53-23.83l19.97-18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M780.1,291.94c2.51,17.41-31.92,61.94-31.92,61.94l-34.5-23.75s9.57-24.53,25.68-40.62c18.42-18.44,38.11-16.54,40.74,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M638.71,358.76l-13.51-13.96-14.41,18.57s10.97,10.6,24.03,7.52l3.88-12.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "606.67 337.04 600.48 356.53 610.8 363.29 625.21 344.73 606.67 337.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M828.33,204.52c-1.13,18.22-.85,28.96-10.02,38.31-13.86,14.08-36.36,5.74-40.69-12.53-3.93-16.39-1.43-43.45,16.41-50.69,12.72-5.23,27.27.85,32.5,13.57,1.47,3.59,2.09,7.47,1.8,11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M844.2,166.46c5.61,5.16,3.23,10.92.3,12,9.1,1.88,10.42,9.12,5.64,24.4-4.56,14.63-15.61,34.25-29.42,35.45-20.75,1.8-26.81-19.82-26.96-41.27-11.73.73-6.66-9.67-21.07-7.27-12.53,2.08-7.82-7.69-18.47-11.95-12.35-5.01-9.87-23.93,1.65-18.49,0,0-5.34,3.51.88,6.82s5.61-4.33,17.91-5.26c12.3-.93,13.73,9.6,28.11,3.26,18.04-7.97,29.89-8.34,41.42,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M837.28,178.36c1.68-2.69,4.93-3.97,7.99-3.13,5.64,1.2,6.09,3.68,9.62,3.36s2.26,3.43,2.26,3.43c0,0-.95-2.83-5.21-1.25-4.26,1.58-7.04-2.28-8.87-.55-1.83,1.73-5.79-1.85-5.79-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M803.58,209.48c-.8,4.47-3.07,8.54-6.44,11.58-4.46,3.96-8.32.78-8.47-4.64,0-4.89,2.08-12.85,7.22-14.76,5.14-1.9,8.62,2.41,7.69,7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M794.51,436.11s20.9,140.64,32.37,193.26c12.53,57.63,99.85,210.97,99.85,210.97l32.07-10.42s-69.53-138.16-76.7-195.31c-7.79-62.01-24.05-198.59-24.05-198.59l-63.54.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M917.76,830.31c-.13,0,7.34,11.23,7.34,11.23l36.03-11.73-4.23-10.77-39.14,11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M807.71,486.22c24.15,4.74,21.6,94.81,18.69,141.14-6.97-32.75-17.16-95.76-24.13-140.49,1.69-.83,3.6-1.06,5.44-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M759.61,436.11s-2.51,137.63-.55,193.76c2.08,58.38,22.55,249.56,22.55,249.56h31.19s1.13-187.77,2.51-245.1c1.5-62.64,9.05-198.22,9.05-198.22h-64.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M775.54,866.99c-.15,0,1.75,12.95,1.75,12.95h37.93l1.03-11.55-40.72-1.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempImg8865);
export default __webpack_public_path__ + "static/media/temp_img_8865.1d49b58b8a7d035c7bb75f53af86eaaf.svg";
export { ForwardRef as ReactComponent };